export function cartPath(): string {
  return '/cart'
}
